export default function matchMedia(query: string) {
    if (typeof window !== 'undefined') {
        return window.matchMedia(query);
    }
    // to avoid NextJs build error
    return { matches: false };
}
